import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
// Components
import { CmxLayoutContainer } from './cmx-layout-container.component';
import { CmxFooterComponent } from './components/cmx-footer/cmx-footer.component';
import { CmxHeaderComponent } from './components/cmx-header/cmx-header.component';
import { CmxLayoutComponent } from './components/cmx-layout/cmx-layout.component';
import { CmxMobileEntitySelectorComponent } from './components/cmx-mobile-entity-selector/cmx-mobile-entity-selector.component';
import { CmxMobileLangSelectorComponent } from './components/cmx-mobile-lang-selector/cmx-mobile-lang-selector.component';
import { CmxChatboxComponent } from './components/cmx-sidebar/cmx-chatbox/cmx-chatbox.component';
import { CmxLegalEntityListingComponent } from './components/cmx-sidebar/cmx-legal-entity-listing/cmx-legal-entity-listing.component';
import { CmxLegalEntityComponent } from './components/cmx-sidebar/cmx-legal-entity/cmx-legal-entity.component';
import { CmxNavMenuComponent } from './components/cmx-sidebar/cmx-nav-menu/cmx-nav-menu.component';
import { CmxSidebarComponent } from './components/cmx-sidebar/cmx-sidebar.component';
import { InlineLoaderComponent } from './components/inline-loader/inline-loader.component';
import { CmxHeaderEmployeeMenuComponent } from './components/cmx-header/cmx-header-employee-menu/cmx-header-employee-menu.component';
import { SwitchComponent } from './components/switch/switch.component';
import { CmxMobileAppSelectorComponent } from './components/cmx-mobile-app-selector/cmx-mobile-app-selector.component';
// Services
import { ButtonEventsService } from './services/button-events.service';
import { CmxLayoutService } from './services/cmx-layout.service';
import { LegalEntityService } from './services/legal-entity.service';
import { MenuService } from './services/menu.service';
// Directives and Pipes
import { ScrollDirective } from './directives/scroll.directive';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { NotificationsService } from './services/notifications.service';
import { CmxNotificationsComponent } from './components/cmx-header/cmx-notifications/cmx-notifications.component';
import { CmxChatbotModule } from '@cemex/cmx-chatbot-v15';

@NgModule({
  declarations: [
    CmxLayoutComponent,
    CmxHeaderComponent,
    CmxSidebarComponent,
    CmxFooterComponent,
    InlineLoaderComponent,
    ScrollDirective,
    CmxLegalEntityListingComponent,
    CmxLegalEntityComponent,
    CmxNavMenuComponent,
    CmxLayoutContainer,
    CmxMobileLangSelectorComponent,
    CmxMobileEntitySelectorComponent,
    EllipsisPipe,
    HighlightPipe,
    CmxChatboxComponent,
    CmxHeaderEmployeeMenuComponent,
    SwitchComponent,
    CmxMobileAppSelectorComponent,
    CmxNotificationsComponent,
  ],
  imports: [CommonModule, FormsModule, CmxChatbotModule],
  providers: [CmxLayoutService, ButtonEventsService, LegalEntityService, NotificationsService, MenuService],
  exports: [CmxLayoutContainer],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class CmxLayoutModule {}
